module.exports = __webpack_public_path__ + "img/map.efd1971e.png";